import * as StageStatus from '../stageStatus';

function jump(version: string): void {
    if (version === 'v1.0.0') {
        window.location.href = StageStatus.getVersion1Url(window.location.href);
    }
    else if (version === 'v2.0.0') {
        window.location.href = StageStatus.getVersion2Url(window.location.href);
    }
}

export {
    jump
};
